import React from 'react';
import * as C from 'src/pages/indicators/EditIndicatorPage/_components/EditorPagination/styles';

interface ITab {
	id: string | number,
	content: React.ReactNode | string,
   
}
export interface IEditorPaginationProps {
	tabs: ITab[];
	onChange?: (id: string | number) => void
	containerStyles?: React.CSSProperties;
}

export default function EditorPagination({ tabs, onChange, containerStyles, }:IEditorPaginationProps) {

  
	const [ selected, setSelected, ] = React.useState(tabs?.at(0)?.id ?? '');

	React.useEffect(() => {
		onChange && onChange(selected);
	}, [ selected, ]);

    

	const tabContent = tabs.map((tab) => (
		<C.Tab onClick={() => {
			setSelected(tab.id);
		}} key={tab.id} isSelected={tab.id === selected}
		>
			{tab.content}
		</C.Tab>
	));

	return (
		<C.TabsContainer style={containerStyles}>
			{tabContent}
		</C.TabsContainer>
	);
}
